"use client";

import { createSystem, defaultConfig } from "@chakra-ui/react";
import { SYSTEM_COMMON } from "./common";

export const SYSTEM_ACOUNT_GITDULUX = createSystem(
  defaultConfig,
  SYSTEM_COMMON,
  {
    theme: {
      tokens: {
        colors: {
          primary: {
            50: { value: "#F8F7FB" },
            100: { value: "#E4DDEE" },
            200: { value: "#CCC1DF" },
            300: { value: "#B09ECD" },
            400: { value: "#A08AC3" },
            500: { value: "#8B70B6" },
            600: { value: "#795AAA" },
            700: { value: "#65419E" },
            800: { value: "#573095" },
            900: { value: "#402171" },
          },
          secondary: {
            50: { value: "#F8F7FB" },
            100: { value: "#E4DDEE" },
            200: { value: "#CCC1DF" },
            300: { value: "#B09ECD" },
            400: { value: "#A08AC3" },
            500: { value: "#8B70B6" },
            600: { value: "#795AAA" },
            700: { value: "#65419E" },
            800: { value: "#573095" },
            900: { value: "#402171" },
          },
        },
      },
    },
  },
);
